import { render } from "./goodsSearch.vue?vue&type=template&id=587b76b4&scoped=true"
import script from "./goodsSearch.vue?vue&type=script&lang=js"
export * from "./goodsSearch.vue?vue&type=script&lang=js"

import "./goodsSearch.vue?vue&type=style&index=0&id=587b76b4&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587b76b4"]])

export default __exports__